import Vue from 'vue'
import Vuex from 'vuex'
import Meta from 'vue-meta'
import ClientOnly from 'vue-client-only'
import NoSsr from 'vue-no-ssr'
import { createRouter } from './router.js'
import NuxtChild from './components/nuxt-child.js'
import NuxtError from '../layouts/error.vue'
import Nuxt from './components/nuxt.js'
import App from './App.js'
import { setContext, getLocation, getRouteData, normalizeError } from './utils'
import { createStore } from './store.js'

/* Plugins */

import nuxt_plugin_plugin_1db1a366 from 'nuxt_plugin_plugin_1db1a366' // Source: ./components/plugin.js (mode: 'all')
import nuxt_plugin_onesignal_91eafe6a from 'nuxt_plugin_onesignal_91eafe6a' // Source: ./onesignal.js (mode: 'client')
import nuxt_plugin_plugin_ff92fe7e from 'nuxt_plugin_plugin_ff92fe7e' // Source: ./vuetify/plugin.js (mode: 'all')
import nuxt_plugin_pluginutils_98186890 from 'nuxt_plugin_pluginutils_98186890' // Source: ./nuxt-i18n/plugin.utils.js (mode: 'all')
import nuxt_plugin_pluginrouting_3c304b03 from 'nuxt_plugin_pluginrouting_3c304b03' // Source: ./nuxt-i18n/plugin.routing.js (mode: 'all')
import nuxt_plugin_pluginmain_5a559168 from 'nuxt_plugin_pluginmain_5a559168' // Source: ./nuxt-i18n/plugin.main.js (mode: 'all')
import nuxt_plugin_gtm_22654879 from 'nuxt_plugin_gtm_22654879' // Source: ./gtm.js (mode: 'all')
import nuxt_plugin_image_6a51a1de from 'nuxt_plugin_image_6a51a1de' // Source: ./image.js (mode: 'all')
import nuxt_plugin_plugin_669724ac from 'nuxt_plugin_plugin_669724ac' // Source: ./nuxt-speedkit/plugin.js (mode: 'all')
import nuxt_plugin_deviceplugin_0ca6ad24 from 'nuxt_plugin_deviceplugin_0ca6ad24' // Source: ./device.plugin.js (mode: 'all')
import nuxt_plugin_nuxtmq_2cd9f92b from 'nuxt_plugin_nuxtmq_2cd9f92b' // Source: ./nuxt-mq.js (mode: 'all')
import nuxt_plugin_vuesocialsharingplugin_2e90df48 from 'nuxt_plugin_vuesocialsharingplugin_2e90df48' // Source: ./vue-social-sharing-plugin.js (mode: 'all')
import nuxt_plugin_axios_7f4aa4e3 from 'nuxt_plugin_axios_7f4aa4e3' // Source: ./axios.js (mode: 'all')
import nuxt_plugin_workbox_59056d3f from 'nuxt_plugin_workbox_59056d3f' // Source: ./workbox.js (mode: 'client')
import nuxt_plugin_metaplugin_350df55c from 'nuxt_plugin_metaplugin_350df55c' // Source: ./pwa/meta.plugin.js (mode: 'all')
import nuxt_plugin_vuelazyloadvideo_fe5c511c from 'nuxt_plugin_vuelazyloadvideo_fe5c511c' // Source: ../plugins/vue-lazyload-video.js (mode: 'client')
import nuxt_plugin_vscrolllock_a40204c4 from 'nuxt_plugin_vscrolllock_a40204c4' // Source: ../plugins/v-scroll-lock (mode: 'client')
import nuxt_plugin_vuetify_512965c0 from 'nuxt_plugin_vuetify_512965c0' // Source: ../plugins/vuetify.js (mode: 'all')
import nuxt_plugin_datefilter_f4b26092 from 'nuxt_plugin_datefilter_f4b26092' // Source: ../plugins/date-filter.js (mode: 'all')
import nuxt_plugin_vuecarousel_4b1a23ce from 'nuxt_plugin_vuecarousel_4b1a23ce' // Source: ../plugins/vue-carousel.js (mode: 'client')
import nuxt_plugin_vuelazyload_211b2937 from 'nuxt_plugin_vuelazyload_211b2937' // Source: ../plugins/vue-lazyload (mode: 'client')
import nuxt_plugin_vuetouch_737c6982 from 'nuxt_plugin_vuetouch_737c6982' // Source: ../plugins/vue-touch (mode: 'client')
import nuxt_plugin_vuerx_3319a6d4 from 'nuxt_plugin_vuerx_3319a6d4' // Source: ../plugins/vuerx (mode: 'client')
import nuxt_plugin_vueyoutube_e2e19eb4 from 'nuxt_plugin_vueyoutube_e2e19eb4' // Source: ../plugins/vue-youtube (mode: 'client')
import nuxt_plugin_vimeoplayer_400597e1 from 'nuxt_plugin_vimeoplayer_400597e1' // Source: ../plugins/vimeo-player (mode: 'client')
import nuxt_plugin_directives_521c0486 from 'nuxt_plugin_directives_521c0486' // Source: ../plugins/directives.js (mode: 'client')
import nuxt_plugin_googlemaps_01826562 from 'nuxt_plugin_googlemaps_01826562' // Source: ../plugins/google-maps.js (mode: 'all')
import nuxt_plugin_vuemapbox_5e7e456b from 'nuxt_plugin_vuemapbox_5e7e456b' // Source: ../plugins/vue-mapbox.js (mode: 'client')
import nuxt_plugin_chat_12dc7b69 from 'nuxt_plugin_chat_12dc7b69' // Source: ../plugins/chat.js (mode: 'client')
import nuxt_plugin_chatProvider_f7040c90 from 'nuxt_plugin_chatProvider_f7040c90' // Source: ../plugins/chatProvider.js (mode: 'client')
import nuxt_plugin_gtmpageview_220a6c60 from 'nuxt_plugin_gtmpageview_220a6c60' // Source: ../plugins/gtm-pageview.js (mode: 'client')

// Component: <ClientOnly>
Vue.component(ClientOnly.name, ClientOnly)

// TODO: Remove in Nuxt 3: <NoSsr>
Vue.component(NoSsr.name, {
  ...NoSsr,
  render (h, ctx) {
    if (process.client && !NoSsr._warned) {
      NoSsr._warned = true

      console.warn('<no-ssr> has been deprecated and will be removed in Nuxt 3, please use <client-only> instead')
    }
    return NoSsr.render(h, ctx)
  }
})

// Component: <NuxtChild>
Vue.component(NuxtChild.name, NuxtChild)
Vue.component('NChild', NuxtChild)

// Component NuxtLink is imported in server.js or client.js

// Component: <Nuxt>
Vue.component(Nuxt.name, Nuxt)

Object.defineProperty(Vue.prototype, '$nuxt', {
  get() {
    const globalNuxt = this.$root ? this.$root.$options.$nuxt : null
    if (process.client && !globalNuxt && typeof window !== 'undefined') {
      return window.$nuxt
    }
    return globalNuxt
  },
  configurable: true
})

Vue.use(Meta, {"keyName":"head","attribute":"data-n-head","ssrAttribute":"data-n-head-ssr","tagIDKeyName":"hid"})

const defaultTransition = {"name":"page","mode":"out-in","appear":false,"appearClass":"appear","appearActiveClass":"appear-active","appearToClass":"appear-to"}

const originalRegisterModule = Vuex.Store.prototype.registerModule

function registerModule (path, rawModule, options = {}) {
  const preserveState = process.client && (
    Array.isArray(path)
      ? !!path.reduce((namespacedState, path) => namespacedState && namespacedState[path], this.state)
      : path in this.state
  )
  return originalRegisterModule.call(this, path, rawModule, { preserveState, ...options })
}

async function createApp(ssrContext, config = {}) {
  const store = createStore(ssrContext)
  const router = await createRouter(ssrContext, config, { store })

  // Add this.$router into store actions/mutations
  store.$router = router

  // Fix SSR caveat https://github.com/nuxt/nuxt.js/issues/3757#issuecomment-414689141
  store.registerModule = registerModule

  // Create Root instance

  // here we inject the router and store to all child components,
  // making them available everywhere as `this.$router` and `this.$store`.
  const app = {
    head: {"htmlAttrs":{"lang":"en"},"title":"Pepper Tix","meta":[{"charset":"utf-8"},{"name":"viewport","content":"width=device-width, initial-scale=1,maximum-scale=1, user-scalable=0, shrink-to-fit=no"},{"name":"apple-mobile-web-app-capable","content":"yes"},{"hid":"description","name":"description","content":"Your home events tickets for concerts, sports, theatre and special events"},{"hid":"description","property":"og:description","content":"Your home events tickets for concerts, sports, theatre and special events"},{"hid":"fb:app_id","property":"fb:app_id","content":"1580071112297891"}],"link":[{"rel":"icon","type":"image\u002Fx-icon","href":"\u002Ffavi-pepper.png"},{"rel":"stylesheet","type":"text\u002Fcss","href":"https:\u002F\u002Ffonts.googleapis.com\u002Fcss?family=Material+Icons"}],"script":[{},{"type":"text\u002Fjavascript","hid":"signin","body":true,"async":true,"innerHTML":"\n        window.fbAsyncInit = function() {\n          FB.init({\n            appId: \"1580071112297891\",\n            cookie: true, \u002F\u002F enable cookies to allow the server to access the session\n            xfbml: true, \u002F\u002F parse social plugins on this page\n            version: \"v20.0\" \u002F\u002F use graph api version 2.8\n          });\n        };\n\n        (function (d, s, id) {\n          var js;\n          var fjs = d.getElementsByTagName(s)[0];\n          if (d.getElementById(id)) return;\n          js = d.createElement(s);\n          js.id = id;\n          js.src = \"https:\u002F\u002Fconnect.facebook.net\u002Fen_US\u002Fsdk.js\";\n          fjs.parentNode.insertBefore(js, fjs);\n        })(document, \"script\", \"facebook-jssdk\");\n        "},{"hid":"gtm-script","innerHTML":"if(!window._gtm_init){window._gtm_init=1;(function(w,n,d,m,e,p){w[d]=(w[d]==1||n[d]=='yes'||n[d]==1||n[m]==1||(w[e]&&w[e][p]&&w[e][p]()))?1:0})(window,navigator,'doNotTrack','msDoNotTrack','external','msTrackingProtectionEnabled');(function(w,d,s,l,x,y){w[x]={};w._gtm_inject=function(i){if(w.doNotTrack||w[x][i])return;w[x][i]=1;w[l]=w[l]||[];w[l].push({'gtm.start':new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],j=d.createElement(s);j.defer=true;j.src='https:\u002F\u002Fwww.googletagmanager.com\u002Fgtm.js?id='+i;f.parentNode.insertBefore(j,f);};w[y]('GTM-P63HHPN')})(window,document,'script','dataLayer','_gtm_ids','_gtm_inject')}"},{"async":true,"src":"https:\u002F\u002Fcdn.onesignal.com\u002Fsdks\u002FOneSignalSDK.js","hid":"onesignal"}],"style":[],"noscript":[{"hid":"gtm-noscript","pbody":true,"innerHTML":"\u003Ciframe src=\"https:\u002F\u002Fwww.googletagmanager.com\u002Fns.html?id=GTM-P63HHPN&\" height=\"0\" width=\"0\" style=\"display:none;visibility:hidden\" title=\"gtm\"\u003E\u003C\u002Fiframe\u003E"}],"__dangerouslyDisableSanitizersByTagID":{"gtm-script":["innerHTML"],"gtm-noscript":["innerHTML"]}},

    store,
    router,
    nuxt: {
      defaultTransition,
      transitions: [defaultTransition],
      setTransitions (transitions) {
        if (!Array.isArray(transitions)) {
          transitions = [transitions]
        }
        transitions = transitions.map((transition) => {
          if (!transition) {
            transition = defaultTransition
          } else if (typeof transition === 'string') {
            transition = Object.assign({}, defaultTransition, { name: transition })
          } else {
            transition = Object.assign({}, defaultTransition, transition)
          }
          return transition
        })
        this.$options.nuxt.transitions = transitions
        return transitions
      },

      err: null,
      errPageReady: false,
      dateErr: null,
      error (err) {
        err = err || null
        app.context._errored = Boolean(err)
        err = err ? normalizeError(err) : null
        let nuxt = app.nuxt // to work with @vue/composition-api, see https://github.com/nuxt/nuxt.js/issues/6517#issuecomment-573280207
        if (this) {
          nuxt = this.nuxt || this.$options.nuxt
        }
        nuxt.dateErr = Date.now()
        nuxt.err = err
        nuxt.errPageReady = false
        // Used in src/server.js
        if (ssrContext) {
          ssrContext.nuxt.error = err
        }
        return err
      }
    },
    ...App
  }

  // Make app available into store via this.app
  store.app = app

  const next = ssrContext ? ssrContext.next : location => app.router.push(location)
  // Resolve route
  let route
  if (ssrContext) {
    route = router.resolve(ssrContext.url).route
  } else {
    const path = getLocation(router.options.base, router.options.mode)
    route = router.resolve(path).route
  }

  // Set context to app.context
  await setContext(app, {
    store,
    route,
    next,
    error: app.nuxt.error.bind(app),
    payload: ssrContext ? ssrContext.payload : undefined,
    req: ssrContext ? ssrContext.req : undefined,
    res: ssrContext ? ssrContext.res : undefined,
    beforeRenderFns: ssrContext ? ssrContext.beforeRenderFns : undefined,
    beforeSerializeFns: ssrContext ? ssrContext.beforeSerializeFns : undefined,
    ssrContext
  })

  function inject(key, value) {
    if (!key) {
      throw new Error('inject(key, value) has no key provided')
    }
    if (value === undefined) {
      throw new Error(`inject('${key}', value) has no value provided`)
    }

    key = '$' + key
    // Add into app
    app[key] = value
    // Add into context
    if (!app.context[key]) {
      app.context[key] = value
    }

    // Add into store
    store[key] = app[key]

    // Check if plugin not already installed
    const installKey = '__nuxt_' + key + '_installed__'
    if (Vue[installKey]) {
      return
    }
    Vue[installKey] = true
    // Call Vue.use() to install the plugin into vm
    Vue.use(() => {
      if (!Object.prototype.hasOwnProperty.call(Vue.prototype, key)) {
        Object.defineProperty(Vue.prototype, key, {
          get () {
            return this.$root.$options[key]
          }
        })
      }
    })
  }

  // Inject runtime config as $config
  inject('config', config)

  if (process.client) {
    // Replace store state before plugins execution
    if (window.__NUXT__ && window.__NUXT__.state) {
      store.replaceState(window.__NUXT__.state)
    }
  }

  // Add enablePreview(previewData = {}) in context for plugins
  if (process.static && process.client) {
    app.context.enablePreview = function (previewData = {}) {
      app.previewData = Object.assign({}, previewData)
      inject('preview', previewData)
    }
  }
  // Plugin execution

  if (typeof nuxt_plugin_plugin_1db1a366 === 'function') {
    await nuxt_plugin_plugin_1db1a366(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_onesignal_91eafe6a === 'function') {
    await nuxt_plugin_onesignal_91eafe6a(app.context, inject)
  }

  if (typeof nuxt_plugin_plugin_ff92fe7e === 'function') {
    await nuxt_plugin_plugin_ff92fe7e(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginutils_98186890 === 'function') {
    await nuxt_plugin_pluginutils_98186890(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginrouting_3c304b03 === 'function') {
    await nuxt_plugin_pluginrouting_3c304b03(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginmain_5a559168 === 'function') {
    await nuxt_plugin_pluginmain_5a559168(app.context, inject)
  }

  if (typeof nuxt_plugin_gtm_22654879 === 'function') {
    await nuxt_plugin_gtm_22654879(app.context, inject)
  }

  if (typeof nuxt_plugin_image_6a51a1de === 'function') {
    await nuxt_plugin_image_6a51a1de(app.context, inject)
  }

  if (typeof nuxt_plugin_plugin_669724ac === 'function') {
    await nuxt_plugin_plugin_669724ac(app.context, inject)
  }

  if (typeof nuxt_plugin_deviceplugin_0ca6ad24 === 'function') {
    await nuxt_plugin_deviceplugin_0ca6ad24(app.context, inject)
  }

  if (typeof nuxt_plugin_nuxtmq_2cd9f92b === 'function') {
    await nuxt_plugin_nuxtmq_2cd9f92b(app.context, inject)
  }

  if (typeof nuxt_plugin_vuesocialsharingplugin_2e90df48 === 'function') {
    await nuxt_plugin_vuesocialsharingplugin_2e90df48(app.context, inject)
  }

  if (typeof nuxt_plugin_axios_7f4aa4e3 === 'function') {
    await nuxt_plugin_axios_7f4aa4e3(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_workbox_59056d3f === 'function') {
    await nuxt_plugin_workbox_59056d3f(app.context, inject)
  }

  if (typeof nuxt_plugin_metaplugin_350df55c === 'function') {
    await nuxt_plugin_metaplugin_350df55c(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vuelazyloadvideo_fe5c511c === 'function') {
    await nuxt_plugin_vuelazyloadvideo_fe5c511c(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vscrolllock_a40204c4 === 'function') {
    await nuxt_plugin_vscrolllock_a40204c4(app.context, inject)
  }

  if (typeof nuxt_plugin_vuetify_512965c0 === 'function') {
    await nuxt_plugin_vuetify_512965c0(app.context, inject)
  }

  if (typeof nuxt_plugin_datefilter_f4b26092 === 'function') {
    await nuxt_plugin_datefilter_f4b26092(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vuecarousel_4b1a23ce === 'function') {
    await nuxt_plugin_vuecarousel_4b1a23ce(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vuelazyload_211b2937 === 'function') {
    await nuxt_plugin_vuelazyload_211b2937(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vuetouch_737c6982 === 'function') {
    await nuxt_plugin_vuetouch_737c6982(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vuerx_3319a6d4 === 'function') {
    await nuxt_plugin_vuerx_3319a6d4(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vueyoutube_e2e19eb4 === 'function') {
    await nuxt_plugin_vueyoutube_e2e19eb4(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vimeoplayer_400597e1 === 'function') {
    await nuxt_plugin_vimeoplayer_400597e1(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_directives_521c0486 === 'function') {
    await nuxt_plugin_directives_521c0486(app.context, inject)
  }

  if (typeof nuxt_plugin_googlemaps_01826562 === 'function') {
    await nuxt_plugin_googlemaps_01826562(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vuemapbox_5e7e456b === 'function') {
    await nuxt_plugin_vuemapbox_5e7e456b(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_chat_12dc7b69 === 'function') {
    await nuxt_plugin_chat_12dc7b69(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_chatProvider_f7040c90 === 'function') {
    await nuxt_plugin_chatProvider_f7040c90(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_gtmpageview_220a6c60 === 'function') {
    await nuxt_plugin_gtmpageview_220a6c60(app.context, inject)
  }

  // Lock enablePreview in context
  if (process.static && process.client) {
    app.context.enablePreview = function () {
      console.warn('You cannot call enablePreview() outside a plugin.')
    }
  }

  // Wait for async component to be resolved first
  await new Promise((resolve, reject) => {
    // Ignore 404s rather than blindly replacing URL in browser
    if (process.client) {
      const { route } = router.resolve(app.context.route.fullPath)
      if (!route.matched.length) {
        return resolve()
      }
    }
    router.replace(app.context.route.fullPath, resolve, (err) => {
      // https://github.com/vuejs/vue-router/blob/v3.4.3/src/util/errors.js
      if (!err._isRouter) return reject(err)
      if (err.type !== 2 /* NavigationFailureType.redirected */) return resolve()

      // navigated to a different route in router guard
      const unregister = router.afterEach(async (to, from) => {
        if (process.server && ssrContext && ssrContext.url) {
          ssrContext.url = to.fullPath
        }
        app.context.route = await getRouteData(to)
        app.context.params = to.params || {}
        app.context.query = to.query || {}
        unregister()
        resolve()
      })
    })
  })

  return {
    store,
    app,
    router
  }
}

export { createApp, NuxtError }
